import { logInDev } from "../../debug";
import { getActionNameFromInput, getInputNameForKey } from "./keyHandler";

type MouseHandler = (inputName: string, args?: any) => void;

class InputState {
  keyHandlers: Array<string[] | string>;
  inputHandlers: Array<string[] | string>;
  mouseHandler?: MouseHandler;
  constructor() {
    this.keyHandlers = [];
    this.inputHandlers = [];
  }

  addMouseHandler(fn: MouseHandler) {
    this.mouseHandler = fn;
  }

  pushKeyHandler(handlers: string | string[]) {
    logInDev(
      `Adding Key Handlers ${
        Array.isArray(handlers) ? handlers.join(",") : handlers
      }`
    );
    this.keyHandlers.push(handlers);
  }

  popKeyHandler() {
    this.keyHandlers.pop();
  }

  pushInputHandler(handlers: string | string[]) {
    logInDev(
      `Adding Input Handlers ${
        Array.isArray(handlers) ? handlers.join(",") : handlers
      }`
    );
    this.inputHandlers.push(handlers);
  }

  popInputHandler() {
    this.inputHandlers.pop();
  }

  keyToAction(keyCode: string) {
    if (!this.inputHandlers.length || !this.keyHandlers.length) {
      return;
    }
    return getActionNameFromInput(
      this.inputHandlers[this.inputHandlers.length - 1],
      getInputNameForKey(this.keyHandlers[this.keyHandlers.length - 1], keyCode)
    );
  }

  inputToActionName(inputName: string) {
    return getActionNameFromInput(
      this.inputHandlers[this.inputHandlers.length - 1],
      inputName
    );
  }

  triggerMouseAction(inputName: string, args?: any) {
    this.mouseHandler && this.mouseHandler(inputName, args);
  }
}

export default new InputState();
